import { Dayjs } from 'date';
import { MaterialComponentValueSchema } from 'features';
import { type InferType, type SchemaInput, yup } from 'form';
import { BaseTradeSignalSchema } from '../BaseTradeSignalSchema/BaseTradeSignalSchema';

export const DemandSignalSchema = BaseTradeSignalSchema.shape({
  buyer_material_spec_id: yup.number().optional(),
  latest_delivery_date: yup.mixed<Dayjs>().optional(),
  material_component_values: yup.array().of(MaterialComponentValueSchema).required(),
  material_grade_id: yup.number().required(),
  material_spec_id: yup.number().required(),
  port_of_discharge_id: yup.number().optional(),
});

export type DemandSignalFormValues = InferType<typeof DemandSignalSchema>;
export type DemandSignalFormInputValues = SchemaInput<typeof DemandSignalSchema>;
